export default __webpack_public_path__ + "static/media/06.1ea4cde0.jpg";